import * as read_api from "./alan_api";
function serialize_aggregate($_aggregate: read_api.Caggregate) {
	const raw_data: Record<string, any> = {};
	raw_data["collection"] = $_aggregate.properties.collection.entry;
	raw_data["head"] = serialize_node_path($_aggregate.properties.head);
	raw_data["tail"] = serialize_node_path($_aggregate.properties.tail);
	return raw_data;
}
function serialize_collection_path($_collection_path: read_api.Ccollection_path) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_steps: Record<string, any>;
		switch ($_collection_path.properties.has_steps.state.name) {
			case 'no': {
				const $_no__has_steps__collection_path = $_collection_path.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_steps = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_steps__collection_path = $_collection_path.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["collection"] = $_yes__has_steps__collection_path.properties.collection.entry;
				raw_data["head"] = serialize_conditional_child_path($_yes__has_steps__collection_path.properties.head);
				raw_data["tail"] = serialize_collection_path($_yes__has_steps__collection_path.properties.tail);
				raw_has_steps = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_collection_path.properties.has_steps.state)
		}
		raw_data["has steps"] = [$_collection_path.properties.has_steps.state.name, raw_has_steps];
	}
	return raw_data;
}
function serialize_collection_query_path($_collection_query_path: read_api.Ccollection_query_path) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_steps: Record<string, any>;
		switch ($_collection_query_path.properties.has_steps.state.name) {
			case 'no': {
				const $_no__has_steps__collection_query_path = $_collection_query_path.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_steps = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_steps__collection_query_path = $_collection_query_path.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["collection"] = $_yes__has_steps__collection_query_path.properties.collection.entry;
				raw_data["head"] = serialize_conditional_child_path($_yes__has_steps__collection_query_path.properties.head);
				raw_data["tail"] = serialize_collection_query_path($_yes__has_steps__collection_query_path.properties.tail);
				{
					let raw_type: Record<string, any>;
					switch ($_yes__has_steps__collection_query_path.properties.type.state.name) {
						case 'candidates': {
							const $_candidates = $_yes__has_steps__collection_query_path.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							{
								let raw_include_reference: Record<string, any>;
								switch ($_candidates.properties.include_reference.state.name) {
									case 'no': {
										const $_no__include_reference__candidates = $_candidates.properties.include_reference.state.node;
										const raw_data: Record<string, any> = {};
										raw_include_reference = raw_data
										break;
									}
									case 'yes': {
										const $_yes__include_reference__candidates = $_candidates.properties.include_reference.state.node;
										const raw_data: Record<string, any> = {};
										raw_include_reference = raw_data
										break;
									}
									default:
										throw new Error("unexpected state: " + $_candidates.properties.include_reference.state)
								}
								raw_data["include reference"] = [$_candidates.properties.include_reference.state.name, raw_include_reference];
							}
							raw_type = raw_data
							break;
						}
						case 'existing entries': {
							const $_existing_entries = $_yes__has_steps__collection_query_path.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_type = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_yes__has_steps__collection_query_path.properties.type.state)
					}
					raw_data["type"] = [$_yes__has_steps__collection_query_path.properties.type.state.name, raw_type];
				}
				raw_has_steps = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_collection_query_path.properties.has_steps.state)
		}
		raw_data["has steps"] = [$_collection_query_path.properties.has_steps.state.name, raw_has_steps];
	}
	return raw_data;
}
function serialize_conditional_child_path($_conditional_child_path: read_api.Cconditional_child_path) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_steps: Record<string, any>;
		switch ($_conditional_child_path.properties.has_steps.state.name) {
			case 'no': {
				const $_no__has_steps__conditional_child_path = $_conditional_child_path.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_steps = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_steps__conditional_child_path = $_conditional_child_path.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["tail"] = serialize_conditional_child_path($_yes__has_steps__conditional_child_path.properties.tail);
				{
					let raw_type: Record<string, any>;
					switch ($_yes__has_steps__conditional_child_path.properties.type.state.name) {
						case 'group': {
							const $_group__type__yes__has_steps__conditional_child_path = $_yes__has_steps__conditional_child_path.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["group"] = $_group__type__yes__has_steps__conditional_child_path.properties.group.entry;
							raw_type = raw_data
							break;
						}
						case 'state': {
							const $_state__type__yes__has_steps__conditional_child_path = $_yes__has_steps__conditional_child_path.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["state"] = $_state__type__yes__has_steps__conditional_child_path.properties.state.entry;
							raw_data["state group"] = $_state__type__yes__has_steps__conditional_child_path.properties.state_group.entry;
							raw_type = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_yes__has_steps__conditional_child_path.properties.type.state)
					}
					raw_data["type"] = [$_yes__has_steps__conditional_child_path.properties.type.state.name, raw_type];
				}
				raw_has_steps = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_conditional_child_path.properties.has_steps.state)
		}
		raw_data["has steps"] = [$_conditional_child_path.properties.has_steps.state.name, raw_has_steps];
	}
	return raw_data;
}
function serialize_entry_point_path($_entry_point_path: read_api.Centry_point_path) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_steps: Record<string, any>;
		switch ($_entry_point_path.properties.has_steps.state.name) {
			case 'no': {
				const $_no__has_steps__entry_point_path = $_entry_point_path.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["text"] = $_no__has_steps__entry_point_path.properties.text.entry;
				raw_has_steps = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_steps__entry_point_path = $_entry_point_path.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["collection"] = $_yes__has_steps__entry_point_path.properties.collection.entry;
				raw_data["head"] = serialize_conditional_child_path($_yes__has_steps__entry_point_path.properties.head);
				raw_data["tail"] = serialize_entry_point_path($_yes__has_steps__entry_point_path.properties.tail);
				raw_has_steps = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_entry_point_path.properties.has_steps.state)
		}
		raw_data["has steps"] = [$_entry_point_path.properties.has_steps.state.name, raw_has_steps];
	}
	return raw_data;
}
function serialize_filter_expression($_filter_expression: read_api.Cfilter_expression) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_more_steps: Record<string, any>;
		switch ($_filter_expression.properties.has_more_steps.state.name) {
			case 'no': {
				const $_no__has_more_steps = $_filter_expression.properties.has_more_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_more_steps = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_more_steps = $_filter_expression.properties.has_more_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["tail"] = serialize_filter_expression($_yes__has_more_steps.properties.tail);
				raw_has_more_steps = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_filter_expression.properties.has_more_steps.state)
		}
		raw_data["has more steps"] = [$_filter_expression.properties.has_more_steps.state.name, raw_has_more_steps];
	}
	{
		let raw_type: Record<string, any>;
		switch ($_filter_expression.properties.type.state.name) {
			case 'alternatives': {
				const $_alternatives__type = $_filter_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				const raw_alternatives: Record<string, any> = {};
				for (let [k,v] of $_alternatives__type.properties.alternatives) {
					const $_alternatives__alternatives = v;
					const raw_data: Record<string, any> = {};
					raw_alternatives[k] = raw_data
				}
				raw_data["alternatives"] = raw_alternatives;
				raw_type = raw_data
				break;
			}
			case 'wildcard': {
				const $_wildcard = $_filter_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_type = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_filter_expression.properties.type.state)
		}
		raw_data["type"] = [$_filter_expression.properties.type.state.name, raw_type];
	}
	return raw_data;
}
function serialize_id_path($_id_path__client_request: read_api.Cid_path__client_request) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_steps: Record<string, any>;
		switch ($_id_path__client_request.properties.has_steps.state.name) {
			case 'no': {
				const $_no__has_steps__id_path = $_id_path__client_request.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_steps = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_steps__id_path = $_id_path__client_request.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["tail"] = serialize_id_path($_yes__has_steps__id_path.properties.tail);
				{
					let raw_type: Record<string, any>;
					switch ($_yes__has_steps__id_path.properties.type.state.name) {
						case 'collection entry': {
							const $_collection_entry__type__yes__has_steps__id_path = $_yes__has_steps__id_path.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["collection"] = $_collection_entry__type__yes__has_steps__id_path.properties.collection.entry;
							raw_data["id"] = $_collection_entry__type__yes__has_steps__id_path.properties.id;
							raw_type = raw_data
							break;
						}
						case 'group': {
							const $_group__type__yes__has_steps__id_path = $_yes__has_steps__id_path.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["group"] = $_group__type__yes__has_steps__id_path.properties.group.entry;
							raw_type = raw_data
							break;
						}
						case 'state': {
							const $_state__type__yes__has_steps__id_path = $_yes__has_steps__id_path.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["state"] = $_state__type__yes__has_steps__id_path.properties.state.entry;
							raw_data["state group"] = $_state__type__yes__has_steps__id_path.properties.state_group.entry;
							raw_type = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_yes__has_steps__id_path.properties.type.state)
					}
					raw_data["type"] = [$_yes__has_steps__id_path.properties.type.state.name, raw_type];
				}
				raw_has_steps = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_id_path__client_request.properties.has_steps.state)
		}
		raw_data["has steps"] = [$_id_path__client_request.properties.has_steps.state.name, raw_has_steps];
	}
	return raw_data;
}
function serialize_node_initialization($_node_initialization: read_api.Cnode_initialization) {
	const raw_data: Record<string, any> = {};
	const raw_properties: Record<string, any> = {};
	for (let [k,v] of $_node_initialization.properties.properties) {
		const $_properties__node_initialization = v;
		const raw_data: Record<string, any> = {};
		{
			let raw_type: Record<string, any>;
			switch ($_properties__node_initialization.properties.type.state.name) {
				case 'collection': {
					const $_collection__type__properties__node_initialization = $_properties__node_initialization.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					const raw_entries: Record<string, any> = {};
					for (let [k,v] of $_collection__type__properties__node_initialization.properties.entries) {
						const $_entries__collection__type__properties__node_initialization = v;
						const raw_data: Record<string, any> = {};
						raw_data["initialization"] = serialize_node_initialization($_entries__collection__type__properties__node_initialization.properties.initialization);
						raw_entries[k] = raw_data
					}
					raw_data["entries"] = raw_entries;
					raw_type = raw_data
					break;
				}
				case 'file': {
					const $_file__type__properties__node_initialization = $_properties__node_initialization.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["extension"] = $_file__type__properties__node_initialization.properties.extension;
					raw_data["token"] = $_file__type__properties__node_initialization.properties.token;
					raw_type = raw_data
					break;
				}
				case 'group': {
					const $_group__type__properties__node_initialization = $_properties__node_initialization.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["initialization"] = serialize_node_initialization($_group__type__properties__node_initialization.properties.initialization);
					raw_type = raw_data
					break;
				}
				case 'number': {
					const $_number__type__properties__node_initialization = $_properties__node_initialization.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["value"] = $_number__type__properties__node_initialization.properties.value.value;
					raw_type = raw_data
					break;
				}
				case 'state group': {
					const $_state_group__type__properties__node_initialization = $_properties__node_initialization.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["initialization"] = serialize_node_initialization($_state_group__type__properties__node_initialization.properties.initialization);
					raw_data["state"] = $_state_group__type__properties__node_initialization.properties.state.entry;
					raw_type = raw_data
					break;
				}
				case 'text': {
					const $_text__type__properties__node_initialization = $_properties__node_initialization.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["value"] = $_text__type__properties__node_initialization.properties.value;
					raw_type = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_properties__node_initialization.properties.type.state)
			}
			raw_data["type"] = [$_properties__node_initialization.properties.type.state.name, raw_type];
		}
		raw_properties[k] = raw_data
	}
	raw_data["properties"] = raw_properties;
	return raw_data;
}
function serialize_node_path($_node_path: read_api.Cnode_path) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_steps: Record<string, any>;
		switch ($_node_path.properties.has_steps.state.name) {
			case 'no': {
				const $_no__has_steps__node_path = $_node_path.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_steps = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_steps__node_path = $_node_path.properties.has_steps.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["tail"] = serialize_node_path($_yes__has_steps__node_path.properties.tail);
				{
					let raw_type: Record<string, any>;
					switch ($_yes__has_steps__node_path.properties.type.state.name) {
						case 'collection entry': {
							const $_collection_entry__type__yes__has_steps__node_path = $_yes__has_steps__node_path.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["collection"] = $_collection_entry__type__yes__has_steps__node_path.properties.collection.entry;
							raw_data["entry key"] = $_collection_entry__type__yes__has_steps__node_path.properties.entry_key;
							raw_type = raw_data
							break;
						}
						case 'group': {
							const $_group__type__yes__has_steps__node_path = $_yes__has_steps__node_path.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["group"] = $_group__type__yes__has_steps__node_path.properties.group.entry;
							raw_type = raw_data
							break;
						}
						case 'parent': {
							const $_parent = $_yes__has_steps__node_path.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_type = raw_data
							break;
						}
						case 'reference': {
							const $_reference = $_yes__has_steps__node_path.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["text"] = $_reference.properties.text.entry;
							raw_type = raw_data
							break;
						}
						case 'reference rule': {
							const $_reference_rule = $_yes__has_steps__node_path.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["property"] = $_reference_rule.properties.property.entry;
							raw_data["rule"] = $_reference_rule.properties.rule.entry;
							raw_type = raw_data
							break;
						}
						case 'state': {
							const $_state__type__yes__has_steps__node_path = $_yes__has_steps__node_path.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["state"] = $_state__type__yes__has_steps__node_path.properties.state.entry;
							raw_data["state group"] = $_state__type__yes__has_steps__node_path.properties.state_group.entry;
							raw_type = raw_data
							break;
						}
						case 'state rule': {
							const $_state_rule = $_yes__has_steps__node_path.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["rule"] = $_state_rule.properties.rule.entry;
							raw_type = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_yes__has_steps__node_path.properties.type.state)
					}
					raw_data["type"] = [$_yes__has_steps__node_path.properties.type.state.name, raw_type];
				}
				raw_has_steps = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_node_path.properties.has_steps.state)
		}
		raw_data["has steps"] = [$_node_path.properties.has_steps.state.name, raw_has_steps];
	}
	return raw_data;
}
function serialize_node_query($_node_query: read_api.Cnode_query) {
	const raw_data: Record<string, any> = {};
	const raw_properties: Record<string, any> = {};
	for (let [k,v] of $_node_query.properties.properties) {
		const $_properties__node_query = v;
		const raw_data: Record<string, any> = {};
		raw_data["path"] = serialize_node_path($_properties__node_query.properties.path);
		{
			let raw_type: Record<string, any>;
			switch ($_properties__node_query.properties.type.state.name) {
				case 'collection': {
					const $_collection__type__properties__node_query = $_properties__node_query.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["collection"] = $_collection__type__properties__node_query.properties.collection.entry;
					{
						let raw_include_graph_endpoints: Record<string, any>;
						switch ($_collection__type__properties__node_query.properties.include_graph_endpoints.state.name) {
							case 'no': {
								const $_no__include_graph_endpoints__collection__type__properties = $_collection__type__properties__node_query.properties.include_graph_endpoints.state.node;
								const raw_data: Record<string, any> = {};
								raw_include_graph_endpoints = raw_data
								break;
							}
							case 'yes': {
								const $_yes__include_graph_endpoints__collection__type__properties = $_collection__type__properties__node_query.properties.include_graph_endpoints.state.node;
								const raw_data: Record<string, any> = {};
								raw_include_graph_endpoints = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_collection__type__properties__node_query.properties.include_graph_endpoints.state)
						}
						raw_data["include graph endpoints"] = [$_collection__type__properties__node_query.properties.include_graph_endpoints.state.name, raw_include_graph_endpoints];
					}
					raw_data["properties"] = serialize_node_query($_collection__type__properties__node_query.properties.properties);
					raw_type = raw_data
					break;
				}
				case 'file': {
					const $_file__type__properties__node_query = $_properties__node_query.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["file"] = $_file__type__properties__node_query.properties.file.entry;
					raw_type = raw_data
					break;
				}
				case 'id path': {
					const $_id_path__type = $_properties__node_query.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_type = raw_data
					break;
				}
				case 'number': {
					const $_number__type__properties__node_query = $_properties__node_query.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["expression"] = serialize_number_expression($_number__type__properties__node_query.properties.expression);
					raw_type = raw_data
					break;
				}
				case 'state group': {
					const $_state_group__type__properties__node_query = $_properties__node_query.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["state group"] = $_state_group__type__properties__node_query.properties.state_group.entry;
					raw_type = raw_data
					break;
				}
				case 'text': {
					const $_text__type__properties__node_query = $_properties__node_query.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["expression"] = serialize_text_expression($_text__type__properties__node_query.properties.expression);
					raw_type = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_properties__node_query.properties.type.state)
			}
			raw_data["type"] = [$_properties__node_query.properties.type.state.name, raw_type];
		}
		raw_properties[k] = raw_data
	}
	raw_data["properties"] = raw_properties;
	return raw_data;
}
function serialize_node_subscription($_node_subscription: read_api.Cnode_subscription) {
	const raw_data: Record<string, any> = {};
	const raw_attributes: Record<string, any> = {};
	for (let [k,v] of $_node_subscription.properties.attributes) {
		const $_attributes = v;
		const raw_data: Record<string, any> = {};
		{
			let raw_type: Record<string, any>;
			switch ($_attributes.properties.type.state.name) {
				case 'command': {
					const $_command = $_attributes.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_type = raw_data
					break;
				}
				case 'property': {
					const $_property__type__attributes = $_attributes.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					{
						let raw_type: Record<string, any>;
						switch ($_property__type__attributes.properties.type.state.name) {
							case 'collection': {
								const $_collection__type__property__type__attributes = $_property__type__attributes.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								{
									let raw_include_graph_endpoints: Record<string, any>;
									switch ($_collection__type__property__type__attributes.properties.include_graph_endpoints.state.name) {
										case 'no': {
											const $_no__include_graph_endpoints__collection__type__property = $_collection__type__property__type__attributes.properties.include_graph_endpoints.state.node;
											const raw_data: Record<string, any> = {};
											raw_include_graph_endpoints = raw_data
											break;
										}
										case 'yes': {
											const $_yes__include_graph_endpoints__collection__type__property = $_collection__type__property__type__attributes.properties.include_graph_endpoints.state.node;
											const raw_data: Record<string, any> = {};
											raw_include_graph_endpoints = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_collection__type__property__type__attributes.properties.include_graph_endpoints.state)
									}
									raw_data["include graph endpoints"] = [$_collection__type__property__type__attributes.properties.include_graph_endpoints.state.name, raw_include_graph_endpoints];
								}
								{
									let raw_subscribe_on: Record<string, any>;
									switch ($_collection__type__property__type__attributes.properties.subscribe_on.state.name) {
										case 'entries': {
											const $_entries__subscribe_on = $_collection__type__property__type__attributes.properties.subscribe_on.state.node;
											const raw_data: Record<string, any> = {};
											{
												let raw_key_filter: Record<string, any>;
												switch ($_entries__subscribe_on.properties.key_filter.state.name) {
													case 'no': {
														const $_no__key_filter = $_entries__subscribe_on.properties.key_filter.state.node;
														const raw_data: Record<string, any> = {};
														raw_key_filter = raw_data
														break;
													}
													case 'yes': {
														const $_yes__key_filter = $_entries__subscribe_on.properties.key_filter.state.node;
														const raw_data: Record<string, any> = {};
														const raw_keys: Record<string, any> = {};
														for (let [k,v] of $_yes__key_filter.properties.keys) {
															const $_keys__yes = v;
															const raw_data: Record<string, any> = {};
															raw_keys[k] = raw_data
														}
														raw_data["keys"] = raw_keys;
														raw_key_filter = raw_data
														break;
													}
													default:
														throw new Error("unexpected state: " + $_entries__subscribe_on.properties.key_filter.state)
												}
												raw_data["key filter"] = [$_entries__subscribe_on.properties.key_filter.state.name, raw_key_filter];
											}
											raw_data["subscription"] = serialize_node_subscription($_entries__subscribe_on.properties.subscription);
											raw_subscribe_on = raw_data
											break;
										}
										case 'updates': {
											const $_updates = $_collection__type__property__type__attributes.properties.subscribe_on.state.node;
											const raw_data: Record<string, any> = {};
											raw_subscribe_on = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_collection__type__property__type__attributes.properties.subscribe_on.state)
									}
									raw_data["subscribe on"] = [$_collection__type__property__type__attributes.properties.subscribe_on.state.name, raw_subscribe_on];
								}
								raw_type = raw_data
								break;
							}
							case 'file': {
								const $_file__type__property = $_property__type__attributes.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								raw_type = raw_data
								break;
							}
							case 'group': {
								const $_group__type__property = $_property__type__attributes.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["subscription"] = serialize_node_subscription($_group__type__property.properties.subscription);
								raw_type = raw_data
								break;
							}
							case 'number': {
								const $_number__type__property__type__attributes = $_property__type__attributes.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								raw_type = raw_data
								break;
							}
							case 'state group': {
								const $_state_group__type__property__type__attributes = $_property__type__attributes.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								const raw_states: Record<string, any> = {};
								for (let [k,v] of $_state_group__type__property__type__attributes.properties.states) {
									const $_states__state_group = v;
									const raw_data: Record<string, any> = {};
									raw_data["subscription"] = serialize_node_subscription($_states__state_group.properties.subscription);
									raw_states[k] = raw_data
								}
								raw_data["states"] = raw_states;
								raw_type = raw_data
								break;
							}
							case 'text': {
								const $_text__type__property__type__attributes = $_property__type__attributes.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								{
									let raw_include_reference: Record<string, any>;
									switch ($_text__type__property__type__attributes.properties.include_reference.state.name) {
										case 'no': {
											const $_no__include_reference__text = $_text__type__property__type__attributes.properties.include_reference.state.node;
											const raw_data: Record<string, any> = {};
											raw_include_reference = raw_data
											break;
										}
										case 'yes': {
											const $_yes__include_reference__text = $_text__type__property__type__attributes.properties.include_reference.state.node;
											const raw_data: Record<string, any> = {};
											raw_include_reference = raw_data
											break;
										}
										default:
											throw new Error("unexpected state: " + $_text__type__property__type__attributes.properties.include_reference.state)
									}
									raw_data["include reference"] = [$_text__type__property__type__attributes.properties.include_reference.state.name, raw_include_reference];
								}
								raw_type = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_property__type__attributes.properties.type.state)
						}
						raw_data["type"] = [$_property__type__attributes.properties.type.state.name, raw_type];
					}
					raw_type = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_attributes.properties.type.state)
			}
			raw_data["type"] = [$_attributes.properties.type.state.name, raw_type];
		}
		raw_attributes[k] = raw_data
	}
	raw_data["attributes"] = raw_attributes;
	return raw_data;
}
function serialize_node_update($_node_update: read_api.Cnode_update) {
	const raw_data: Record<string, any> = {};
	const raw_properties: Record<string, any> = {};
	for (let [k,v] of $_node_update.properties.properties) {
		const $_properties__node_update = v;
		const raw_data: Record<string, any> = {};
		{
			let raw_type: Record<string, any>;
			switch ($_properties__node_update.properties.type.state.name) {
				case 'collection': {
					const $_collection__type__properties__node_update = $_properties__node_update.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					const raw_entries: Record<string, any> = {};
					for (let [k,v] of $_collection__type__properties__node_update.properties.entries) {
						const $_entries__collection__type__properties__node_update = v;
						const raw_data: Record<string, any> = {};
						{
							let raw_type: Record<string, any>;
							switch ($_entries__collection__type__properties__node_update.properties.type.state.name) {
								case 'create': {
									const $_create = $_entries__collection__type__properties__node_update.properties.type.state.node;
									const raw_data: Record<string, any> = {};
									raw_data["initialization"] = serialize_node_initialization($_create.properties.initialization);
									raw_type = raw_data
									break;
								}
								case 'remove': {
									const $_remove = $_entries__collection__type__properties__node_update.properties.type.state.node;
									const raw_data: Record<string, any> = {};
									raw_type = raw_data
									break;
								}
								case 'update': {
									const $_update__type__entries = $_entries__collection__type__properties__node_update.properties.type.state.node;
									const raw_data: Record<string, any> = {};
									raw_data["update"] = serialize_node_update($_update__type__entries.properties.update);
									raw_type = raw_data
									break;
								}
								default:
									throw new Error("unexpected state: " + $_entries__collection__type__properties__node_update.properties.type.state)
							}
							raw_data["type"] = [$_entries__collection__type__properties__node_update.properties.type.state.name, raw_type];
						}
						raw_entries[k] = raw_data
					}
					raw_data["entries"] = raw_entries;
					raw_type = raw_data
					break;
				}
				case 'file': {
					const $_file__type__properties__node_update = $_properties__node_update.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["new extension"] = $_file__type__properties__node_update.properties.new_extension;
					raw_data["new token"] = $_file__type__properties__node_update.properties.new_token;
					raw_type = raw_data
					break;
				}
				case 'group': {
					const $_group__type__properties__node_update = $_properties__node_update.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["update"] = serialize_node_update($_group__type__properties__node_update.properties.update);
					raw_type = raw_data
					break;
				}
				case 'number': {
					const $_number__type__properties__node_update = $_properties__node_update.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["new value"] = $_number__type__properties__node_update.properties.new_value.value;
					raw_type = raw_data
					break;
				}
				case 'state group': {
					const $_state_group__type__properties__node_update = $_properties__node_update.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["state"] = $_state_group__type__properties__node_update.properties.state.entry;
					{
						let raw_type: Record<string, any>;
						switch ($_state_group__type__properties__node_update.properties.type.state.name) {
							case 'set': {
								const $_set = $_state_group__type__properties__node_update.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["initialization"] = serialize_node_initialization($_set.properties.initialization);
								raw_type = raw_data
								break;
							}
							case 'update': {
								const $_update__type__state_group = $_state_group__type__properties__node_update.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["update"] = serialize_node_update($_update__type__state_group.properties.update);
								raw_type = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_state_group__type__properties__node_update.properties.type.state)
						}
						raw_data["type"] = [$_state_group__type__properties__node_update.properties.type.state.name, raw_type];
					}
					raw_type = raw_data
					break;
				}
				case 'text': {
					const $_text__type__properties__node_update = $_properties__node_update.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["new value"] = $_text__type__properties__node_update.properties.new_value;
					raw_type = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_properties__node_update.properties.type.state)
			}
			raw_data["type"] = [$_properties__node_update.properties.type.state.name, raw_type];
		}
		raw_properties[k] = raw_data
	}
	raw_data["properties"] = raw_properties;
	return raw_data;
}
function serialize_number_aggregate($_number_aggregate: read_api.Cnumber_aggregate) {
	const raw_data: Record<string, any> = {};
	raw_data["aggregate"] = serialize_aggregate($_number_aggregate.properties.aggregate);
	raw_data["property name"] = $_number_aggregate.properties.property_name.entry;
	return raw_data;
}
function serialize_number_expression($_number_expression: read_api.Cnumber_expression) {
	const raw_data: Record<string, any> = {};
	{
		let raw_type: Record<string, any>;
		switch ($_number_expression.properties.type.state.name) {
			case 'count': {
				const $_count = $_number_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["aggregate"] = serialize_aggregate($_count.properties.aggregate);
				raw_type = raw_data
				break;
			}
			case 'division': {
				const $_division = $_number_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["denominator"] = serialize_signed_number_property($_division.properties.denominator);
				raw_data["numerator"] = serialize_signed_number_property($_division.properties.numerator);
				{
					let raw_rounding: Record<string, any>;
					switch ($_division.properties.rounding.state.name) {
						case 'ceil': {
							const $_ceil = $_division.properties.rounding.state.node;
							const raw_data: Record<string, any> = {};
							raw_rounding = raw_data
							break;
						}
						case 'floor': {
							const $_floor = $_division.properties.rounding.state.node;
							const raw_data: Record<string, any> = {};
							raw_rounding = raw_data
							break;
						}
						case 'ordinary': {
							const $_ordinary = $_division.properties.rounding.state.node;
							const raw_data: Record<string, any> = {};
							raw_rounding = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_division.properties.rounding.state)
					}
					raw_data["rounding"] = [$_division.properties.rounding.state.name, raw_rounding];
				}
				raw_type = raw_data
				break;
			}
			case 'maximum': {
				const $_maximum = $_number_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["left expression"] = serialize_number_expression($_maximum.properties.left_expression);
				raw_data["right expression"] = serialize_number_expression($_maximum.properties.right_expression);
				raw_type = raw_data
				break;
			}
			case 'minimum': {
				const $_minimum = $_number_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["left expression"] = serialize_number_expression($_minimum.properties.left_expression);
				raw_data["right expression"] = serialize_number_expression($_minimum.properties.right_expression);
				raw_type = raw_data
				break;
			}
			case 'number property': {
				const $_number_property = $_number_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["signed number property"] = serialize_signed_number_property($_number_property.properties.signed_number_property);
				raw_type = raw_data
				break;
			}
			case 'product': {
				const $_product = $_number_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["numbers"] = serialize_signed_number_property_list($_product.properties.numbers);
				raw_type = raw_data
				break;
			}
			case 'remainder': {
				const $_remainder = $_number_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["modulus"] = serialize_signed_number_property($_remainder.properties.modulus);
				raw_data["number"] = serialize_signed_number_property($_remainder.properties.number);
				raw_type = raw_data
				break;
			}
			case 'state based': {
				const $_state_based = $_number_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["path"] = serialize_node_path($_state_based.properties.path);
				raw_data["state group"] = $_state_based.properties.state_group.entry;
				const raw_states: Record<string, any> = {};
				for (let [k,v] of $_state_based.properties.states) {
					const $_states__state_based = v;
					const raw_data: Record<string, any> = {};
					raw_data["value"] = serialize_number_expression($_states__state_based.properties.value);
					raw_states[k] = raw_data
				}
				raw_data["states"] = raw_states;
				raw_type = raw_data
				break;
			}
			case 'sum': {
				const $_sum = $_number_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["number aggregate"] = serialize_number_aggregate($_sum.properties.number_aggregate);
				raw_type = raw_data
				break;
			}
			case 'sum list': {
				const $_sum_list = $_number_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["numbers"] = serialize_signed_number_property_list($_sum_list.properties.numbers);
				raw_type = raw_data
				break;
			}
			case 'value': {
				const $_value = $_number_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["value"] = $_value.properties.value.value;
				raw_type = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_number_expression.properties.type.state)
		}
		raw_data["type"] = [$_number_expression.properties.type.state.name, raw_type];
	}
	return raw_data;
}
function serialize_number_filter_expression($_number_filter_expression: read_api.Cnumber_filter_expression) {
	const raw_data: Record<string, any> = {};
	{
		let raw_operator: Record<string, any>;
		switch ($_number_filter_expression.properties.operator.state.name) {
			case 'equals': {
				const $_equals = $_number_filter_expression.properties.operator.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["criterium"] = $_equals.properties.criterium.value;
				raw_operator = raw_data
				break;
			}
			case 'range': {
				const $_range = $_number_filter_expression.properties.operator.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_greater_than: Record<string, any>;
					switch ($_range.properties.greater_than.state.name) {
						case 'no': {
							const $_no__greater_than = $_range.properties.greater_than.state.node;
							const raw_data: Record<string, any> = {};
							raw_greater_than = raw_data
							break;
						}
						case 'yes': {
							const $_yes__greater_than = $_range.properties.greater_than.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["criterium"] = $_yes__greater_than.properties.criterium.value;
							raw_greater_than = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_range.properties.greater_than.state)
					}
					raw_data["greater than"] = [$_range.properties.greater_than.state.name, raw_greater_than];
				}
				{
					let raw_less_than: Record<string, any>;
					switch ($_range.properties.less_than.state.name) {
						case 'no': {
							const $_no__less_than = $_range.properties.less_than.state.node;
							const raw_data: Record<string, any> = {};
							raw_less_than = raw_data
							break;
						}
						case 'yes': {
							const $_yes__less_than = $_range.properties.less_than.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["criterium"] = $_yes__less_than.properties.criterium.value;
							raw_less_than = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_range.properties.less_than.state)
					}
					raw_data["less than"] = [$_range.properties.less_than.state.name, raw_less_than];
				}
				raw_operator = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_number_filter_expression.properties.operator.state)
		}
		raw_data["operator"] = [$_number_filter_expression.properties.operator.state.name, raw_operator];
	}
	return raw_data;
}
function serialize_reference_filter_list($_reference_filter_list: read_api.Creference_filter_list) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_alternative: Record<string, any>;
		switch ($_reference_filter_list.properties.has_alternative.state.name) {
			case 'no': {
				const $_no__has_alternative = $_reference_filter_list.properties.has_alternative.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_alternative = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_alternative = $_reference_filter_list.properties.has_alternative.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["alternative"] = serialize_reference_filter_list($_yes__has_alternative.properties.alternative);
				raw_has_alternative = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_reference_filter_list.properties.has_alternative.state)
		}
		raw_data["has alternative"] = [$_reference_filter_list.properties.has_alternative.state.name, raw_has_alternative];
	}
	raw_data["referenced node"] = serialize_id_path($_reference_filter_list.properties.referenced_node);
	return raw_data;
}
function serialize_signed_number_property($_signed_number_property: read_api.Csigned_number_property) {
	const raw_data: Record<string, any> = {};
	raw_data["path"] = serialize_node_path($_signed_number_property.properties.path);
	raw_data["property name"] = $_signed_number_property.properties.property_name.entry;
	{
		let raw_sign: Record<string, any>;
		switch ($_signed_number_property.properties.sign.state.name) {
			case 'negative': {
				const $_negative = $_signed_number_property.properties.sign.state.node;
				const raw_data: Record<string, any> = {};
				raw_sign = raw_data
				break;
			}
			case 'positive': {
				const $_positive = $_signed_number_property.properties.sign.state.node;
				const raw_data: Record<string, any> = {};
				raw_sign = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_signed_number_property.properties.sign.state)
		}
		raw_data["sign"] = [$_signed_number_property.properties.sign.state.name, raw_sign];
	}
	return raw_data;
}
function serialize_signed_number_property_list($_signed_number_property_list: read_api.Csigned_number_property_list) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_element: Record<string, any>;
		switch ($_signed_number_property_list.properties.has_element.state.name) {
			case 'no': {
				const $_no__has_element__signed_number_property_list = $_signed_number_property_list.properties.has_element.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_element = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_element__signed_number_property_list = $_signed_number_property_list.properties.has_element.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["signed number property"] = serialize_signed_number_property($_yes__has_element__signed_number_property_list.properties.signed_number_property);
				raw_data["tail"] = serialize_signed_number_property_list($_yes__has_element__signed_number_property_list.properties.tail);
				raw_has_element = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_signed_number_property_list.properties.has_element.state)
		}
		raw_data["has element"] = [$_signed_number_property_list.properties.has_element.state.name, raw_has_element];
	}
	return raw_data;
}
function serialize_singular_text_expression($_singular_text_expression: read_api.Csingular_text_expression) {
	const raw_data: Record<string, any> = {};
	{
		let raw_type: Record<string, any>;
		switch ($_singular_text_expression.properties.type.state.name) {
			case 'dynamic': {
				const $_dynamic = $_singular_text_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["path"] = serialize_node_path($_dynamic.properties.path);
				raw_data["text"] = $_dynamic.properties.text.entry;
				raw_type = raw_data
				break;
			}
			case 'static': {
				const $_static = $_singular_text_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["string"] = $_static.properties.string;
				raw_type = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_singular_text_expression.properties.type.state)
		}
		raw_data["type"] = [$_singular_text_expression.properties.type.state.name, raw_type];
	}
	return raw_data;
}
function serialize_singular_text_expression_list($_singular_text_expression_list: read_api.Csingular_text_expression_list) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_element: Record<string, any>;
		switch ($_singular_text_expression_list.properties.has_element.state.name) {
			case 'no': {
				const $_no__has_element__singular_text_expression_list = $_singular_text_expression_list.properties.has_element.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_element = raw_data
				break;
			}
			case 'yes': {
				const $_yes__has_element__singular_text_expression_list = $_singular_text_expression_list.properties.has_element.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["singular text expression"] = serialize_singular_text_expression($_yes__has_element__singular_text_expression_list.properties.singular_text_expression);
				raw_data["tail"] = serialize_singular_text_expression_list($_yes__has_element__singular_text_expression_list.properties.tail);
				raw_has_element = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_singular_text_expression_list.properties.has_element.state)
		}
		raw_data["has element"] = [$_singular_text_expression_list.properties.has_element.state.name, raw_has_element];
	}
	return raw_data;
}
function serialize_text_expression($_text_expression: read_api.Ctext_expression) {
	const raw_data: Record<string, any> = {};
	{
		let raw_type: Record<string, any>;
		switch ($_text_expression.properties.type.state.name) {
			case 'concatenation': {
				const $_concatenation = $_text_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["parts"] = serialize_singular_text_expression_list($_concatenation.properties.parts);
				raw_type = raw_data
				break;
			}
			case 'singular': {
				const $_singular = $_text_expression.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["expression"] = serialize_singular_text_expression($_singular.properties.expression);
				raw_type = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_text_expression.properties.type.state)
		}
		raw_data["type"] = [$_text_expression.properties.type.state.name, raw_type];
	}
	return raw_data;
}
export function serialize($_client_request: read_api.Cclient_request) {
	const raw_data: Record<string, any> = {};
	{
		let raw_type: Record<string, any>;
		switch ($_client_request.properties.type.state.name) {
			case 'acyclic graph list query': {
				const $_acyclic_graph_list_query = $_client_request.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["context node"] = serialize_id_path($_acyclic_graph_list_query.properties.context_node);
				raw_data["entry points"] = serialize_entry_point_path($_acyclic_graph_list_query.properties.entry_points);
				raw_data["graph"] = $_acyclic_graph_list_query.properties.graph.entry;
				let raw_query: Record<string, any>;
				{
					const $_query = $_acyclic_graph_list_query.properties.query;
					const raw_data: Record<string, any> = {};
					raw_data["collection path"] = serialize_collection_path($_query.properties.collection_path);
					const raw_properties: Record<string, any> = {};
					for (let [k,v] of $_query.properties.properties) {
						const $_properties__query = v;
						const raw_data: Record<string, any> = {};
						raw_data["path"] = serialize_node_path($_properties__query.properties.path);
						{
							let raw_type: Record<string, any>;
							switch ($_properties__query.properties.type.state.name) {
								case 'number': {
									const $_number__type__properties__query = $_properties__query.properties.type.state.node;
									const raw_data: Record<string, any> = {};
									raw_data["number"] = $_number__type__properties__query.properties.number.entry;
									raw_type = raw_data
									break;
								}
								case 'state group': {
									const $_state_group__type__properties__query = $_properties__query.properties.type.state.node;
									const raw_data: Record<string, any> = {};
									raw_data["state group"] = $_state_group__type__properties__query.properties.state_group.entry;
									raw_type = raw_data
									break;
								}
								case 'text': {
									const $_text__type__properties__query = $_properties__query.properties.type.state.node;
									const raw_data: Record<string, any> = {};
									raw_data["text"] = $_text__type__properties__query.properties.text.entry;
									raw_type = raw_data
									break;
								}
								default:
									throw new Error("unexpected state: " + $_properties__query.properties.type.state)
							}
							raw_data["type"] = [$_properties__query.properties.type.state.name, raw_type];
						}
						raw_properties[k] = raw_data
					}
					raw_data["properties"] = raw_properties;
					raw_query = raw_data
				}
				raw_data["query"] = raw_query;
				raw_type = raw_data
				break;
			}
			case 'acyclic graph tree query': {
				const $_acyclic_graph_tree_query = $_client_request.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["context node"] = serialize_id_path($_acyclic_graph_tree_query.properties.context_node);
				{
					let raw_type: Record<string, any>;
					switch ($_acyclic_graph_tree_query.properties.type.state.name) {
						case 'collection': {
							const $_collection__type__acyclic_graph_tree_query = $_acyclic_graph_tree_query.properties.type.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["graph"] = $_collection__type__acyclic_graph_tree_query.properties.graph.entry;
							raw_type = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_acyclic_graph_tree_query.properties.type.state)
					}
					raw_data["type"] = [$_acyclic_graph_tree_query.properties.type.state.name, raw_type];
				}
				raw_type = raw_data
				break;
			}
			case 'collection query': {
				const $_collection_query = $_client_request.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				const raw_aggregates: Record<string, any> = {};
				for (let [k,v] of $_collection_query.properties.aggregates) {
					const $_aggregates = v;
					const raw_data: Record<string, any> = {};
					{
						let raw_type: Record<string, any>;
						switch ($_aggregates.properties.type.state.name) {
							case 'state distribution': {
								const $_state_distribution = $_aggregates.properties.type.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["path"] = serialize_node_path($_state_distribution.properties.path);
								raw_data["state group"] = $_state_distribution.properties.state_group.entry;
								raw_type = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_aggregates.properties.type.state)
						}
						raw_data["type"] = [$_aggregates.properties.type.state.name, raw_type];
					}
					raw_aggregates[k] = raw_data
				}
				raw_data["aggregates"] = raw_aggregates;
				raw_data["collection path"] = serialize_collection_query_path($_collection_query.properties.collection_path);
				raw_data["context node path"] = serialize_id_path($_collection_query.properties.context_node_path);
				let raw_filters: Record<string, any>;
				{
					const $_filters = $_collection_query.properties.filters;
					const raw_data: Record<string, any> = {};
					{
						let raw_todo_filter: Record<string, any>;
						switch ($_filters.properties.todo_filter.state.name) {
							case 'no': {
								const $_no__todo_filter = $_filters.properties.todo_filter.state.node;
								const raw_data: Record<string, any> = {};
								raw_todo_filter = raw_data
								break;
							}
							case 'yes': {
								const $_yes__todo_filter = $_filters.properties.todo_filter.state.node;
								const raw_data: Record<string, any> = {};
								raw_data["path"] = serialize_node_path($_yes__todo_filter.properties.path);
								raw_todo_filter = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_filters.properties.todo_filter.state)
						}
						raw_data["todo filter"] = [$_filters.properties.todo_filter.state.name, raw_todo_filter];
					}
					const raw_value_filters: Record<string, any> = {};
					for (let [k,v] of $_filters.properties.value_filters) {
						const $_value_filters = v;
						const raw_data: Record<string, any> = {};
						raw_data["path"] = serialize_node_path($_value_filters.properties.path);
						{
							let raw_type: Record<string, any>;
							switch ($_value_filters.properties.type.state.name) {
								case 'node': {
									const $_node = $_value_filters.properties.type.state.node;
									const raw_data: Record<string, any> = {};
									{
										let raw_type: Record<string, any>;
										switch ($_node.properties.type.state.name) {
											case 'containment': {
												const $_containment = $_node.properties.type.state.node;
												const raw_data: Record<string, any> = {};
												{
													let raw_operator: Record<string, any>;
													switch ($_containment.properties.operator.state.name) {
														case 'in': {
															const $_in__operator__containment = $_containment.properties.operator.state.node;
															const raw_data: Record<string, any> = {};
															raw_operator = raw_data
															break;
														}
														case 'not in': {
															const $_not_in__operator__containment = $_containment.properties.operator.state.node;
															const raw_data: Record<string, any> = {};
															raw_operator = raw_data
															break;
														}
														default:
															throw new Error("unexpected state: " + $_containment.properties.operator.state)
													}
													raw_data["operator"] = [$_containment.properties.operator.state.name, raw_operator];
												}
												raw_data["references"] = serialize_reference_filter_list($_containment.properties.references);
												raw_type = raw_data
												break;
											}
											case 'existence': {
												const $_existence = $_node.properties.type.state.node;
												const raw_data: Record<string, any> = {};
												{
													let raw_operator: Record<string, any>;
													switch ($_existence.properties.operator.state.name) {
														case 'exists': {
															const $_exists = $_existence.properties.operator.state.node;
															const raw_data: Record<string, any> = {};
															raw_operator = raw_data
															break;
														}
														case 'not exists': {
															const $_not_exists = $_existence.properties.operator.state.node;
															const raw_data: Record<string, any> = {};
															raw_operator = raw_data
															break;
														}
														default:
															throw new Error("unexpected state: " + $_existence.properties.operator.state)
													}
													raw_data["operator"] = [$_existence.properties.operator.state.name, raw_operator];
												}
												raw_type = raw_data
												break;
											}
											default:
												throw new Error("unexpected state: " + $_node.properties.type.state)
										}
										raw_data["type"] = [$_node.properties.type.state.name, raw_type];
									}
									raw_type = raw_data
									break;
								}
								case 'property': {
									const $_property__type__value_filters = $_value_filters.properties.type.state.node;
									const raw_data: Record<string, any> = {};
									raw_data["property"] = $_property__type__value_filters.properties.property.entry;
									{
										let raw_type: Record<string, any>;
										switch ($_property__type__value_filters.properties.type.state.name) {
											case 'collection': {
												const $_collection__type__property__type__value_filters = $_property__type__value_filters.properties.type.state.node;
												const raw_data: Record<string, any> = {};
												const raw_keys: Record<string, any> = {};
												for (let [k,v] of $_collection__type__property__type__value_filters.properties.keys) {
													const $_keys__collection = v;
													const raw_data: Record<string, any> = {};
													raw_keys[k] = raw_data
												}
												raw_data["keys"] = raw_keys;
												{
													let raw_operator: Record<string, any>;
													switch ($_collection__type__property__type__value_filters.properties.operator.state.name) {
														case 'in': {
															const $_in__operator__collection = $_collection__type__property__type__value_filters.properties.operator.state.node;
															const raw_data: Record<string, any> = {};
															raw_operator = raw_data
															break;
														}
														case 'not in': {
															const $_not_in__operator__collection = $_collection__type__property__type__value_filters.properties.operator.state.node;
															const raw_data: Record<string, any> = {};
															raw_operator = raw_data
															break;
														}
														default:
															throw new Error("unexpected state: " + $_collection__type__property__type__value_filters.properties.operator.state)
													}
													raw_data["operator"] = [$_collection__type__property__type__value_filters.properties.operator.state.name, raw_operator];
												}
												raw_type = raw_data
												break;
											}
											case 'number': {
												const $_number__type__property__type__value_filters = $_property__type__value_filters.properties.type.state.node;
												const raw_data: Record<string, any> = {};
												raw_data["expression"] = serialize_number_filter_expression($_number__type__property__type__value_filters.properties.expression);
												raw_type = raw_data
												break;
											}
											case 'state group': {
												const $_state_group__type__property__type__value_filters = $_property__type__value_filters.properties.type.state.node;
												const raw_data: Record<string, any> = {};
												const raw_states_to_include: Record<string, any> = {};
												for (let [k,v] of $_state_group__type__property__type__value_filters.properties.states_to_include) {
													const $_states_to_include = v;
													const raw_data: Record<string, any> = {};
													raw_states_to_include[k] = raw_data
												}
												raw_data["states to include"] = raw_states_to_include;
												raw_type = raw_data
												break;
											}
											case 'text': {
												const $_text__type__property__type__value_filters = $_property__type__value_filters.properties.type.state.node;
												const raw_data: Record<string, any> = {};
												raw_data["expression"] = serialize_filter_expression($_text__type__property__type__value_filters.properties.expression);
												raw_type = raw_data
												break;
											}
											default:
												throw new Error("unexpected state: " + $_property__type__value_filters.properties.type.state)
										}
										raw_data["type"] = [$_property__type__value_filters.properties.type.state.name, raw_type];
									}
									raw_type = raw_data
									break;
								}
								default:
									throw new Error("unexpected state: " + $_value_filters.properties.type.state)
							}
							raw_data["type"] = [$_value_filters.properties.type.state.name, raw_type];
						}
						raw_value_filters[k] = raw_data
					}
					raw_data["value filters"] = raw_value_filters;
					raw_filters = raw_data
				}
				raw_data["filters"] = raw_filters;
				{
					let raw_select_entries: Record<string, any>;
					switch ($_collection_query.properties.select_entries.state.name) {
						case 'no': {
							const $_no__select_entries = $_collection_query.properties.select_entries.state.node;
							const raw_data: Record<string, any> = {};
							raw_select_entries = raw_data
							break;
						}
						case 'yes': {
							const $_yes__select_entries = $_collection_query.properties.select_entries.state.node;
							const raw_data: Record<string, any> = {};
							raw_data["limit number of entries"] = $_yes__select_entries.properties.limit_number_of_entries.value;
							raw_data["properties"] = serialize_node_query($_yes__select_entries.properties.properties);
							raw_select_entries = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_collection_query.properties.select_entries.state)
					}
					raw_data["select entries"] = [$_collection_query.properties.select_entries.state.name, raw_select_entries];
				}
				raw_type = raw_data
				break;
			}
			case 'command execution': {
				const $_command_execution = $_client_request.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["arguments"] = serialize_node_initialization($_command_execution.properties.arguments);
				raw_data["command"] = $_command_execution.properties.command.entry;
				raw_data["context node"] = serialize_id_path($_command_execution.properties.context_node);
				raw_type = raw_data
				break;
			}
			case 'mutation': {
				const $_mutation = $_client_request.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["context node"] = serialize_id_path($_mutation.properties.context_node);
				raw_data["node update"] = serialize_node_update($_mutation.properties.node_update);
				raw_type = raw_data
				break;
			}
			case 'password mutation': {
				const $_password_mutation = $_client_request.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["new password"] = $_password_mutation.properties.new_password;
				raw_data["old password"] = $_password_mutation.properties.old_password;
				raw_type = raw_data
				break;
			}
			case 'password reset': {
				const $_password_reset = $_client_request.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["username"] = $_password_reset.properties.username;
				raw_type = raw_data
				break;
			}
			case 'subscription': {
				const $_subscription = $_client_request.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["context node"] = serialize_id_path($_subscription.properties.context_node);
				{
					let raw_mutation_permissions: Record<string, any>;
					switch ($_subscription.properties.mutation_permissions.state.name) {
						case 'ignore': {
							const $_ignore = $_subscription.properties.mutation_permissions.state.node;
							const raw_data: Record<string, any> = {};
							raw_mutation_permissions = raw_data
							break;
						}
						case 'include': {
							const $_include = $_subscription.properties.mutation_permissions.state.node;
							const raw_data: Record<string, any> = {};
							raw_mutation_permissions = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_subscription.properties.mutation_permissions.state)
					}
					raw_data["mutation permissions"] = [$_subscription.properties.mutation_permissions.state.name, raw_mutation_permissions];
				}
				raw_data["node subscription"] = serialize_node_subscription($_subscription.properties.node_subscription);
				raw_type = raw_data
				break;
			}
			case 'subscription deletion': {
				const $_subscription_deletion = $_client_request.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				raw_type = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_client_request.properties.type.state)
		}
		raw_data["type"] = [$_client_request.properties.type.state.name, raw_type];
	}
	return raw_data;
}